export default __webpack_public_path__ + "static/media/pc-img-team-en-553-px@2x.0fd50a42.png";